import io from 'socket.io-client';
import JsonRpcAjax from '../utils/transport/jsonrpc';
import JsonRpcWS from '../utils/transport/websockets';
import Promise from 'bluebird';
import Progress from "react-progress-2";
import EventEmitter from "../EventEmitter";
import {AlertWindow} from 'reactis-modal';
import React from 'react';

const host = __MOBILE__ ? 'https://rezervace.lesniklubsiska.cz' : '';

function alertMessage(text) {
	if (!window._store) {
		alert(text)
	}
	else {
		const a = new AlertWindow('Chyba',<span>{text.split("\n").map((item, key) => {return <span key={key}>{item}<br/></span>})}</span>);
		a.show(window._store.dispatch);
	}
}

function initSocket() {
	var ws = 'WebSocket' in window && window.WebSocket.CLOSING === 2;
	let socket;
	if (ws) {
		socket = io();
		socket.on('connect', function () {
			socket.emit('init', {text: 'hello'});
		});
		socket.on('event', function (msg) {
			console.log('EVENT ' + msg.event);
			EventEmitter.emit(msg.event, msg.payload);
		});
	}
	else {
		socket =  {
			connected:false,
			legacyBrowser:true
		}
	}
	return socket;
}

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
class _ApiClient {

	constructor(endpoint = host + '/api') {
		this.endpoint = endpoint;
	}

	call(method, params, options) {
		if (!params) {
			params = {};
		}
		options = {...options};
		params._token = window.CSRF;
		let transportLayer= new JsonRpcAjax(this.endpoint);
		/*if (global.socket.connected) {
			transportLayer = new JsonRpcWS(global.socket);
		}
		else {
			transportLayer = new JsonRpcAjax(this.endpoint);
		}*/

		const promise = new Promise((resolve, reject) => {
			if (options.progress) {
				Progress.show();
			}
			transportLayer.call(method, params, (err, data) => {
				if (options.progress) {
					Progress.hide();
				}
				if (err) {
					if (err.code == 500) {
						alertMessage("Nastala vnitřní chyba a server nebyl schopen dokončit Váš požadavek.\nOpakujte akci později.");
					}
					if (err.code == 401) {
						setTimeout(() => {
							if (__MOBILE__) {
								window.location.reload();
							}
							else {
								window.location = '/';
							}
						}, 750)
					}
					if (err.code == 403) {
						if (err.message) {
							alertMessage(err.message);
						}
						else {
							alertMessage("Nemáte oprávnění akci provést.");
						}
					}
					if (err.code == 1002) {
						if (err.alert) {
							alertMessage(err.message);
						}
					}
					if (err.code == -32603) {
						alertMessage("Neplatný bezpečnostní token.");
						window.location.reload();
					}
					reject(err);
				}
				else {
					resolve(data);
				}
			}, options.name);
		});
		return promise;
	}
}


const ApiClient = _ApiClient;
export default ApiClient;



// WEBPACK FOOTER //
// ./src/helpers/ApiClient.js